import Ajax from "@/api/ajax";
export default{
    //获取运费
    getFreightFushiwu(params) {
        return Ajax.post("/Home/getFreightFushiwu", params);
    },

}